import { ConfirmButton, ConfirmButtonProps } from '../../component/comfirm-button/ConfirmButton';
import { PriceSummary, PriceSummaryProps } from '../../component/price-summary/PriceSummary';

interface ProductOptionFooterSectionProps {
  display: boolean;
  displayPriceSummary: boolean;
  displayConfirmButton: boolean;
  priceSummary: PriceSummaryProps;
  confirmButton: ConfirmButtonProps;
}

export const ProductOptionFooterSection = (props: ProductOptionFooterSectionProps) => {
  const { display, displayPriceSummary, displayConfirmButton, priceSummary, confirmButton } = props;

  if (!display || (!displayPriceSummary && !displayConfirmButton)) {
    return null;
  }

  return (
    <div>
      {displayPriceSummary && (
        <PriceSummary disabledCoupon={priceSummary.disabledCoupon} priceSummary={priceSummary.priceSummary} />
      )}
      {displayConfirmButton && <ConfirmButton payload={confirmButton.payload} buttons={confirmButton.buttons} />}
    </div>
  );
};
